export function departmentReference(value) {
  if (!value || typeof value !== 'object') return value || null;
  return value['@id'] || (value.id != null ? `/api/departments/${value.id}` : null);
}
export function employeeReference(value) {
  if (!value || typeof value !== 'object') return value || null;
  return value['@id'] || (value.id != null ? `/api/employees/${value.id}` : null);
}
export function departmentId(value) {
  const ref = departmentReference(value);
  return value && typeof value === 'object' && value.id != null ? String(value.id) : ref ? String(ref).split('/').pop() : null;
}
export function managesDepartment(user, department) {
  const id = departmentId(department);
  return !!id && Array.isArray(user?.managedDepartments) && user.managedDepartments.some(item => departmentId(item) === id);
}
export function canReassignTicket(user, department, assignee) {
  if (!user) return false;
  const assigned = employeeReference(assignee);
  const userRef = employeeReference(user);
  return !!(user.roles?.includes('ROLE_ADMIN') || user.roles?.includes('ROLE_SYSTEMS') ||
    managesDepartment(user, department) || (assigned && userRef && assigned === userRef));
}

export function assigneeNeedsVerification(assignee, originalAssignee, loading, error) {
  return !!assignee && employeeReference(assignee) !== employeeReference(originalAssignee) && (loading || error);
}
